const TransactionStatusEnum = Object.freeze({
    Successful : 'successful',
    Pending: 'pending',
    Failed: 'failed',
})

export default TransactionStatusEnum;